import { formatDynamicFields } from 'utils/graphqlUtils'

export const noteFields = `
  id
  grinUserId
  a_doctor
  createdAt
  attachments
  body
  isPinned
  metadata
  visibility
  _deleted
`

export const getUserNotesSorted = fields => /* GraphQL */ `
  query UserNotesSorted(
    $grinUserId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserNoteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userNotesSorted(
      grinUserId: $grinUserId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        ${formatDynamicFields(fields)}
      }
      nextToken
      startedAt
    }
  }
`

export const searchUserNotes = fields => /* GraphQL */ `
  query SearchUserNotes(
    $sort: SearchableUserNoteSortInput
    $filter: SearchableUserNoteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    searchUserNotes(
      sort: $sort
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      nextToken
      items {
        ${formatDynamicFields(fields)}
      }
    }
  }
`
